import { Box, Menu, styled } from '@mui/material';

export const StyledHeaderBox = styled(Box)`
  max-width: 100vw;
  height: ${(theme) => theme.theme.spacing(10)};
  display: flex;
`;

export const StyledMenu = styled(Menu)``;
